import { gql } from '@apollo/client';

export const GET_WORKSPACE_ROLES = gql`
  query Query($workspaceId: Int!) {
    getWorkspaceUserRoles(workspaceId: $workspaceId) {
      name
      rolePermission {
        roleId
        permission {
          name
        }
      }
    }
  }
`;

export const GET_ROLES_INFO = gql`
query GetRolesInfo {
  roles {
    roles {
      id
      name
      updatedBy
      creator {
        id
        firstName
        lastName
      }
      updater {
        id
        firstName
        lastName
      }
    }
  }
}
`;
